import {AbstractSearchCriteria} from '../../criteria/abstract-search-criteria';

export class AllocationFeatureSearchCriteria extends AbstractSearchCriteria {
    serviceType: '';
    kcCompany: '';
}
